export const CREATOR_COLLECTIONS_LINK_ID =
    'listings-root__link-to-creator-collections';
export const CREATOR_COLLECTIONS_LINK_MOBILE_ID =
    'listings-root__link-to-creator-collections--mobile';
export const RELATED_COLLECTIONS_ID =
    'listings-root__collections-related-to-this-event';
export const MANY_COLLECTIONS_LIMIT = 9;
export const COLLECTIONS_PAGE_SIZE = 24;
export const MODAL_LAYOUT_COLUMNS = 3;
